module.exports = __webpack_public_path__ + "img/wide.be5030ca.webp";